<template v-if="attribute">
  <span :value="value" style="line-height: 1px;"><input :id="id" :disabled="isReadOnly" type="radio" v-model="attribute.ref.value" :value="value"></span>
</template>

<script>

/*

Wenn der ReadOnlyAnalyzer genutzt werden soll muss man über die FormField-Component gehen, da nur die den ReadOnlyAnalyzer auswertet
ggf. in der rdb-xml.xml Type-Tag angeben:
    <Tag Name="Type" Value="byte" />

Nutzung: 
<label><RadioField :attribute="data._.MIP_ZUWENDUNGSANTRAG.$$.MT_EINHALTUNG_VORSCHRIFT_JN" :value="true"/>Ja</label> <br/>
<label><RadioField :attribute="data._.MIP_ZUWENDUNGSANTRAG.$$.MT_EINHALTUNG_VORSCHRIFT_JN" :value="false"/>Nein</label> <br/>
*/

import Attribute from "../../xmlrdb-data/Attribute"


export default {
  name: "radioField",
  props: {
    attribute: Attribute,
    value: {
      required: true
    },
    isReadOnly: Boolean,
    id: String
  },
  // Steuert in der Attribute - Komponente ob das erzeugte Label als Click-Label für die Input-Komponente agieren soll
  clickableAttributeLabel: true, 
  setup(props){
  }
}

</script>

<style scoped>

.STATUS_ERROR, .STATUS_WARNING{
  border-radius: 16px;
}
</style>